import { createClient } from "graphql-ws";

/**
 * Creates a graphql-ws client pointing at the gateway WebSocket endpoint.
 *
 * The gateway has `websocket.headers.source: connection`, so the Bearer token
 * is passed in the `connection_init` payload — the standard pattern for
 * browser clients that cannot set arbitrary HTTP headers during the WS handshake.
 *
 * Usage: create inside a React effect, call `client.dispose()` on cleanup.
 */
export function createWsClient(accessToken: string) {
  const httpUrl = import.meta.env.VITE_GATEWAY_URL as string;
  const wsUrl = httpUrl.replace(/^http/, "ws");

  return createClient({
    url: wsUrl,
    connectionParams: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
}
